import React, { useState } from 'react';
import { Search, Music, Zap, Key, Sparkles, Music2, ChevronLeft, ChevronRight } from 'lucide-react';
import SamplePad from './SamplePad';
import FXPanel from './FXPanel';

const SidePanel = ({ 
  isOpen, 
  side, 
  deck, 
  mode, 
  deckState = { eq: { low: 0, mid: 0, high: 0 }, track: null, bpm: null, position: 0, duration: 0 },
  tracks = [],
  audioContextStarted,
  audioContext,
  onEQChange,
  onLoadTrack,
  onToggle
}) => {
  const deckColor = deck === 'A' ? '#00d4ff' : '#ff6b35';
  
  return (
    <>
      {/* Toggle Tab - Positioned OUTSIDE the modal */}
      <button 
        className={`panel-toggle-tab ${side} ${isOpen ? 'open' : ''}`}
        onClick={onToggle}
        style={{ borderColor: isOpen ? deckColor : undefined }}
        data-testid={`panel-toggle-${deck.toLowerCase()}`}
      >
        <div className="toggle-icons">
          <Sparkles size={10} />
          <Music2 size={10} />
        </div>
        <span className="toggle-label" style={{ color: deckColor }}>{deck}</span>
        {side === 'left' ? (
          isOpen ? <ChevronRight size={14} /> : <ChevronLeft size={14} />
        ) : (
          isOpen ? <ChevronLeft size={14} /> : <ChevronRight size={14} />
        )}
      </button>
      
      {/* Panel Content */}
      <div className={`side-panel ${side} ${isOpen ? 'open' : ''}`} data-testid={`side-panel-${deck.toLowerCase()}`}>
        <div className="side-panel-content">
          {/* Panel Header */}
          <div className="side-panel-header" style={{ borderColor: deckColor }}>
            <span className="panel-deck-label" style={{ color: deckColor }}>
              Deck {deck}
            </span>
            <span className="panel-subtitle">Advanced</span>
          </div>
          
          {/* FX Panel */}
          <div className="panel-section">
            <div className="section-title">
              <span>FX</span>
            </div>
            <FXPanel
              deck={deck}
              isEnabled={audioContextStarted}
            />
          </div>
          
          {/* Sample Pads */}
          <div className="panel-section">
            <div className="section-title">
              <span>SAMPLES</span>
            </div>
            <div className="sample-pads-panel">
              {[0, 1, 2, 3].map((i) => (
                <SamplePad
                  key={i}
                  padIndex={i}
                  deck={deck}
                  audioContext={audioContext}
                  isEnabled={audioContextStarted}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidePanel;
